import { render, staticRenderFns } from "./SendStatements.vue?vue&type=template&id=5c291789&"
import script from "./SendStatements.vue?vue&type=script&lang=js&"
export * from "./SendStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports